module.exports = __webpack_public_path__ + "img/download.d0ce2f85.svg";